module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Cooking/Fork-spoon-d772bf7b17701fc18306016a1f30bc06.svg";